import {IntermediateValueControlledNumericInputProps} from 'ui-library/inputs/ControlledNumericInput';
import {NumericInputState} from 'util/Types';

import {RegressionParameterName} from '../RegressionTypes';

export const EMPTY_NUMERIC_INPUT_VALUE: NumericInputState = {numericValue: null, value: '', isValid: true};

export const PARAMETER_NAME_TO_READABLE: {[Param in RegressionParameterName]: string} = {
  [RegressionParameterName.MIN]: 'Min',
  [RegressionParameterName.MAX]: 'Max',
  [RegressionParameterName.IC50]: 'IC50',
  [RegressionParameterName.HILL_SLOPE]: 'Slope',
};

export const CUSTOM_INPUT_PROPERTIES: Partial<{
  [key in RegressionParameterName]: Pick<
    IntermediateValueControlledNumericInputProps,
    'minIsInclusive' | 'min'
  >;
}> = {
  [RegressionParameterName.IC50]: {min: 0, minIsInclusive: false},
};
